import { artifactTypes } from 'shared/constants/artifactTypes';

const allowedArtifactTypes = Object.keys(artifactTypes);

export const allowedForPortfolio = artifactType => allowedArtifactTypes.includes(artifactType);
